import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../Contexts/AuthContext';
import UI_Card from '../../ERUMAUI/UI_Card';
import UI_Input_Text from '../../ERUMAUI/UI_Input_Text';
import UI_Button from '../../ERUMAUI/UI_Button';
import UI_LinearGroup from '../../ERUMAUI/UI_LinearGroup';
import UI_Dropdown from '../../ERUMAUI/UI_Dropdown';
import { useAccounts } from '../../../Contexts/Context_Accounts';
import { useStatus } from '../../../Contexts/Context_Status_Global';
import { useScheduleManagement } from '../../../Contexts/Context_ScheduleManagement';
import UI_Icon from '../../ERUMAUI/UI_Icons';
import UI_Horizontal_Tabs from '../../ERUMAUI/UI_Horizontal_Tabs';
import { useMapRenderer } from '../../../Contexts/Context_MapRenderer';
import Tab_ScheduleManagement_Calendar from '../Tab_ScheduleManagement_Calendar';
import UI_ChipGroup from '../../ERUMAUI/UI_ChipGroup';
import UI_Divider from '../../ERUMAUI/UI_Divider';
import UI_UpdatingStatus from '../../ERUMAUI/UI_UpdatingStatus';
import Icon_Color_Document from '../../../Assets/Icons/Icon_Color_Document.png'
import UI_Toggle from '../../ERUMAUI/UI_Toggle';


export default function Panel_ScheduleManagement_Manager_Right() {
    const { Account, Loading, Logout } = useAuth();
    const { Schedules, Schedules_Pending_Initial, Schedules_Pending_Final, Time_Parse, Time_Range_Parse, Status_Parse, Schedule_Display, Schedule_Information, Schedules_ByUser, Conflicts, Conflict_Check, Conflict_Recommendation, Conflict_Recommendation_Get, Approve_As, Reject_As, Schedule_Reschedule, Schedule_Relocate, Schedule_Edit } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Panel_Right_State, Panel_Toggle } = useStatus();
    // useEffect(() => {
    //     console.error(Schedules);
    // }, [])



    const Handle_Click = async (ID) => {
        await Schedule_Display(ID);
    }

    useEffect(() => {
        if (Schedule_Information) {
            Conflict_Check("Schedule_Information");
            Conflict_Recommendation_Get("Schedule_Information");
        }
    }, [Schedule_Information]);

    const Suggestion_Accept = () => { };

    const User_canManage = Account?.Access?.Reservation?.Approve?.Initial || Account?.Access?.Reservation?.Approve?.Final || Account?.Access?.Reservation?.Edit;

    const User_isOwner = Account?._id === Schedule_Information?.Requester?.RequesterID;
    // const User_isOwnerAndEditable = User_isOwner && (Schedule_Information?.Approval.Initial.State == "Approved" || Schedule_Information?.Approval.Final.State !== "Approved");
    const User_isOwnerAndEditable = User_isOwner &&
        ((Schedule_Information?.Approval.Initial.State === "Pending" && Schedule_Information?.Approval.Final.State === "Pending") ||
            (Schedule_Information?.Approval.Initial.State === "Rejected" || Schedule_Information?.Approval.Final.State === "Rejected"));

    if (Loading) {
        return null;
    }
    return (

        <>
            <div>
                <UI_UpdatingStatus
                    State={Schedule_Information ? "Good" : "Bad"}
                    Good={{
                        Type: "Custom",
                        Content: <>
                            {/* <UI_Divider Text="Actions" /> */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <UI_LinearGroup Fill Gap="Gap">


                                    {Account.Access.Reservation.Edit ?
                                        <UI_Button
                                            Text="Edit details"
                                            Icon={<UI_Icon Name="Edit" />}
                                            Icon_Position="Left"
                                            OnClick={() => Schedule_Edit()}
                                        />
                                        :
                                        User_isOwnerAndEditable ?
                                            <UI_Button
                                                Text="Edit details"
                                                Icon={<UI_Icon Name="Edit" />}
                                                Icon_Position="Left"
                                                OnClick={() => Schedule_Edit("OwnerAndEditable")}
                                            />
                                            :
                                            ""
                                    }
                                </UI_LinearGroup>

                                {Account.Access.Reservation.Edit ?
                                    <UI_LinearGroup Fill Gap="Gap">
                                        <UI_Button
                                            Text="Reschedule"
                                            State="Neutral"
                                            OnClick={() => Schedule_Reschedule()}
                                            Icon={<UI_Icon Name="Reschedule" />}
                                            Icon_Position="Left" />
                                        <UI_Button
                                            Text="Relocate room"
                                            State="Neutral"
                                            OnClick={() => Schedule_Relocate()}
                                            Icon={<UI_Icon Name="Map" />}
                                            Icon_Position="Left" />
                                    </UI_LinearGroup>
                                    :
                                    User_isOwnerAndEditable ?
                                        <UI_LinearGroup Fill Gap="Gap">
                                            <UI_Button
                                                Text="Reschedule"
                                                State="Neutral"
                                                OnClick={() => Schedule_Reschedule("OwnerAndEditable")}
                                                Icon={<UI_Icon Name="Reschedule" />}
                                                Icon_Position="Left" />
                                            <UI_Button
                                                Text="Relocate room"
                                                State="Neutral"
                                                OnClick={() => Schedule_Relocate("OwnerAndEditable")}
                                                Icon={<UI_Icon Name="Map" />}
                                                Icon_Position="Left" />
                                        </UI_LinearGroup>
                                        :
                                        ""
                                }

                                
                                {Account.Access.Reservation.Approve.Initial && Schedule_Information?.Approval.Initial.State == "Pending" ?
                                    <UI_LinearGroup Fill Gap="Gap">
                                        <UI_Button
                                            Text="Reject as OSA"
                                            State="Negative"
                                            OnClick={() => Reject_As("OSA")}
                                            Icon={<UI_Icon Name="Cross" />}
                                            Icon_Position="Left" />
                                        <UI_Button
                                            Text="Approve as OSA"
                                            State="Positive"
                                            OnClick={() => Approve_As("OSA")}
                                            Icon={<UI_Icon Name="Check" />}
                                            Icon_Position="Left" />
                                    </UI_LinearGroup>
                                    :
                                    ""
                                }
                                {Account.Access.Reservation.Approve.Final && Schedule_Information?.Approval.Initial.State != "Rejected" && Schedule_Information?.Approval.Final.State == "Pending" ?
                                    <UI_LinearGroup Fill Gap="Gap">
                                        <UI_Button
                                            Text="Reject as GSU"
                                            State="Negative"
                                            OnClick={() => Reject_As("GSU")}
                                            Icon={<UI_Icon Name="Cross" />}
                                            Icon_Position="Left" />
                                        <UI_Button
                                            Text="Approve as GSU"
                                            State="Positive"
                                            OnClick={() => Approve_As("GSU")}
                                            Icon={<UI_Icon Name="Check" />}
                                            Icon_Position="Left" />
                                    </UI_LinearGroup>
                                    :
                                    ""
                                }

                            </div>
                            {/* <UI_Divider Text="Requested items" />
                            <UI_Toggle
                                id="Toggle_Aircon"
                                Text="Requests for airconditioning use"/> */}
                            <div style={{ marginTop: "20px" }}>
                                <UI_UpdatingStatus
                                    State={(Conflicts.Hard.length + Conflicts.Soft.length) > 0 ? "Bad" : "Good"}
                                    Good={{
                                        Type: "Default",
                                        Icon: "Default",
                                        Title: "No schedule conflicts",
                                        Text: "No schedule conflict detected."
                                    }}
                                    Bad={{
                                        Type: "Custom",
                                        Content: <div>
                                            {Conflicts.Soft.length > 0 ?
                                                <>
                                                    <UI_Divider Text="Class hours" />
                                                    {Conflicts.Soft.map((Item) => (
                                                        <>
                                                            {Item._id != Schedule_Information?._id && Item.BlockedHours ?
                                                                <UI_Card
                                                                    Type="Schedule_List"
                                                                    Figure={
                                                                        {
                                                                            Title: Time_Range_Parse(Item.Time.Start, Item.Time.End, "Time"),
                                                                            Main: "",
                                                                            Chip: Status_Parse(Item)
                                                                        }
                                                                    }
                                                                />
                                                                :
                                                                ""
                                                            }
                                                        </>

                                                    ))}
                                                </>
                                                :
                                                ""
                                            }
                                            {/* {Conflicts.Hard.length + Conflicts.Soft.length > 0 ?
                                                <>
                                                    <UI_Divider Text="Schedule conflicts" />
                                                    <div className='General_List'>
                                                        {Conflicts.Hard.map((Item) => (
                                                            <>
                                                                {Item._id != Schedule_Information?._id ?
                                                                    <UI_Card
                                                                        Type="Schedule_List"
                                                                        Figure={
                                                                            {
                                                                                Title: Item.Name,
                                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                                Chip: Status_Parse(Item)
                                                                            }
                                                                        }
                                                                        onClick={() => Handle_Click(Item._id)}
                                                                    />
                                                                    :
                                                                    ""
                                                                }

                                                            </>

                                                        ))}
                                                        {Conflicts.Soft.map((Item) => (
                                                            <>
                                                                {Item._id != Schedule_Information?._id && !Item.BlockedHours ?
                                                                    <UI_Card
                                                                        Type="Schedule_List"
                                                                        Figure={
                                                                            {
                                                                                Title: Item.Name,
                                                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                                                Chip: Status_Parse(Item)
                                                                            }
                                                                        }
                                                                        onClick={() => Handle_Click(Item._id)}
                                                                    />
                                                                    :
                                                                    ""
                                                                }
                                                            </>

                                                        ))}
                                                    </div>
                                                </>
                                                :
                                                ""
                                            }
                                            
                                            <UI_Divider Text="Time slot suggestions" />
                                            <div className='General_List'>
                                                {Conflict_Recommendation?.Time?.map((Item) => (
                                                    <UI_Card
                                                        Type="Schedule_List"
                                                        Figure={
                                                            {
                                                                Title: Time_Range_Parse(Item.Start, Item.End, "Time"),
                                                                Main: Time_Parse(Item.Start, "Date"),
                                                                Chip: []
                                                            }
                                                        }
                                                        onClick={() => Suggestion_Accept(Item, "Time")}
                                                    />
                                                ))}
                                            </div>
                                            <UI_Divider Text="Room suggestions" />
                                            <div className='General_List'>
                                                {Conflict_Recommendation?.Room?.map((Item) => (
                                                    <UI_Card
                                                        Type="Schedule_List"
                                                        Figure={
                                                            {
                                                                Title: Item.Name,
                                                                Main: "",
                                                                Chip: []
                                                            }
                                                        }
                                                        onClick={() => Suggestion_Accept(Item, "Room")}
                                                    />
                                                ))}
                                            </div> */}
                                        </div>
                                    }} />
                            </div>
                        </>
                    }}
                    Bad={{
                        Type: "Default",
                        Icon: Icon_Color_Document,
                        Title: "No request loaded",
                        Text: "This panel will display the actions for a request once you select one from the queue on the left."
                    }}
                />



            </div>






        </>
    );
}
